import React from 'react';
import { connect } from 'react-redux';

import AboveTheFoldOnlyServerRender from './shared/components/above-the-fold-only-server-render';
import ScripLoader from './page/components/script-loader';

const getGtmUrl = tagName => `https://www.googletagmanager.com/gtm.js?id=${tagName}`;

class ThirdPartyTags extends React.PureComponent {
    static defaultProps = {
        marketing: [
            'https://www.googletagmanager.com/gtm.js?id=GTM-N72GKFZ',
            'https://nexus.ensighten.com/hp/udlmarketing/Bootstrap.js',
        ],
        analytics: ['https://hp.com/cma/ng/lib/exceptions/privacy-banner.js'],
        googleAnalytics: [
            // renderOn and buffer keys allow us to control the GTM load times in isolation; this is important because some
            // GTM containers track analytics and other contain marketing scripts and we want to load them both differently
            { tagName: 'GTM-MZXB4R4', renderOn: 'load' },
            { tagName: 'GTM-N72GKFZ', renderOn: 'idle', buffer: 2000 },
        ],
        abtesting: [],
    };

    render() {
        const { location, analytics, abtesting, googleAnalytics, marketing } = this.props;
        const { query = {} } = location || {};
        const { __disableThirdParty, __3PBuffer } = query;

        if (__disableThirdParty === '*') {
            return null;
        }

        let analyticsBuffer = 0;
        let analyticsLoadStrategy = 'load';

        const idleBuffer = isNaN(query.__3PBuffer) ? 2000 : __3PBuffer * 1;
        const disableMarketing = __disableThirdParty === 'marketing';
        const disableABTest = __disableThirdParty === 'optly';
        const disableAnalytics = __disableThirdParty === 'udl';

        return (
            <React.Fragment>
                {!disableAnalytics && (
                    <AboveTheFoldOnlyServerRender
                        renderOn={analyticsLoadStrategy}
                        skip={true}
                        idleBuffer={analyticsBuffer}
                    >
                        {analytics.map(url => (
                            <ScripLoader key={url} url={url} />
                        ))}
                    </AboveTheFoldOnlyServerRender>
                )}
                {!disableMarketing && (
                    <AboveTheFoldOnlyServerRender renderOn={'idle'} skip={true} idleBuffer={idleBuffer}>
                        {marketing.map(url => (
                            <ScripLoader key={url} url={url} once={true} />
                        ))}
                    </AboveTheFoldOnlyServerRender>
                )}
                {!disableABTest && (
                    <AboveTheFoldOnlyServerRender renderOn={'idle'} skip={true}>
                        {abtesting.map(url => (
                            <ScripLoader key={url} url={url} once={true} />
                        ))}
                    </AboveTheFoldOnlyServerRender>
                )}
                {/* !!! if buffer is not provided in Merch UI it's set to null value (which does not work with default
                     value assignment during ojb property destructuring) */}
                {Array.isArray(googleAnalytics) &&
                    googleAnalytics.map(({ tagName, renderOn = 'idle', buffer }) => (
                        <AboveTheFoldOnlyServerRender
                            key={getGtmUrl(tagName)}
                            renderOn={renderOn}
                            skip={true}
                            idleBuffer={isNaN(buffer) ? idleBuffer : buffer * 1}
                        >
                            <ScripLoader url={getGtmUrl(tagName)} once={true} />
                        </AboveTheFoldOnlyServerRender>
                    ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    //possible tempory for controlling this optimization from page component
    const { router, thirdPartyTags } = state;
    const { location } = router || {};
    let { marketing, abtesting, analytics, googleAnalytics } = thirdPartyTags;
    //TODO: temporarily force defaults for these if someone accidently deletes them all from DB
    marketing = !marketing || marketing.length === 0 ? undefined : marketing;
    analytics = !analytics || analytics.length === 0 ? undefined : analytics;
    googleAnalytics = !googleAnalytics || googleAnalytics.length === 0 ? undefined : googleAnalytics;
    return { location, marketing, abtesting, analytics, googleAnalytics };
};

export default connect(mapStateToProps, null)(ThirdPartyTags);
